import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { hasModifyPermission, hasReadPermission, hasWritePermission } from './filePermissionsUtils';
export const allowCheckIn = (userState, fileColumns) => {
    return userState.id === fileColumns.checkOutUserId;
};
/**
 * Returning true will allow to rename, move, delete, set permissions, manage history.
 * Permission resolution is handled by library for example allowModify => true will assume the read, write is also granted.
 *
 * @param userState - info about logged-in user
 * @param ownerId - owner of particular document
 * @param permissions - document permissions
 */
export const allowModify = (userState, ownerId, permissions) => {
    if (requireAnySystemPermission(userState, 'manage-documents')) {
        return true;
    }
    if (!requireAnyOrgPermission(userState, 'manage-documents', 'view-documents')) {
        return false;
    }
    return hasModifyPermission(userState, ownerId, permissions);
};
export const allowRead = ({ userState, ownerId, permissions, rootLevel, systemUserId }) => {
    if (requireAnySystemPermission(userState, 'manage-documents')) {
        return true;
    }
    if (!requireAnyOrgPermission(userState, 'manage-documents', 'view-documents')) {
        return false;
    }
    if (systemUserId && ownerId === systemUserId) {
        return true;
    }
    return (hasModifyPermission(userState, ownerId, permissions) ||
        hasWritePermission(userState, ownerId, permissions, rootLevel) ||
        hasReadPermission(userState, ownerId, permissions));
};
/**
 * Returning true will allow to create new, check-in, check-out.
 * Permission resolution is handled by library for example allowWrite => true will assume the read is also granted.
 */
export const allowWrite = (params) => {
    var _a, _b, _c, _d;
    const { userState, features, ownerId, permissions, rootLevel, systemUserId } = params;
    if (features) {
        for (const feature of features) {
            const allowWrite = (_d = (_c = (_b = (_a = feature.features) === null || _a === void 0 ? void 0 : _a.documentLibrary) === null || _b === void 0 ? void 0 : _b.additionalFilePermissionAuthorization) === null || _c === void 0 ? void 0 : _c.onAllowWrite) === null || _d === void 0 ? void 0 : _d.call(_c, params);
            if (typeof allowWrite === 'boolean') {
                return allowWrite;
            }
        }
    }
    if (requireAnySystemPermission(userState, 'manage-documents')) {
        return true;
    }
    if (!requireAnyOrgPermission(userState, 'manage-documents', 'view-documents')) {
        return false;
    }
    if (systemUserId && ownerId === systemUserId) {
        return true;
    }
    return hasModifyPermission(userState, ownerId, permissions) || hasWritePermission(userState, ownerId, permissions, rootLevel);
};
